"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortTransactions = void 0;
const luxon_1 = require("luxon");
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/utils/core");
const transactionsTypes_1 = require("companion-app-components/flux/transactions/transactionsTypes");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const utils_1 = require("data/transactions/utils");
const log = (0, core_1.getLogger)('data/transactionList/selectors');
function compareDate(txn1, txn2) {
    const txn1Date = luxon_1.DateTime.fromISO(txn1.postedOn);
    const txn2Date = luxon_1.DateTime.fromISO(txn2.postedOn);
    if (txn1Date < txn2Date) {
        return -1;
    }
    if (txn1Date > txn2Date) {
        return 1;
    }
    return 0;
}
function sortTransactions(txns, optSortBy, optSortOrder, featureFlags) {
    const sortBy = optSortBy !== undefined ? optSortBy : 'date';
    const sortOrder = optSortOrder !== undefined ? optSortOrder : 'descending';
    log.log('In selector performing SORT', sortBy, sortOrder);
    const sortFactor = sortOrder === 'ascending' ? 1 : -1;
    const sortedTxns = (0, immutable_1.List)(txns.toList()).sort((txn1, txn2) => {
        var _a, _b;
        let cmpValue = 0;
        switch (sortBy) {
            case 'payee':
                cmpValue = 1;
                if (txn1.payee === txn2.payee) {
                    cmpValue = compareDate(txn1, txn2);
                    // sometimes payee can be null
                }
                else if (((_a = (txn1.payee || '')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) < ((_b = (txn2.payee || '')) === null || _b === void 0 ? void 0 : _b.toLowerCase())) {
                    cmpValue = -1;
                }
                break;
            case 'check': {
                cmpValue = 1;
                const aChecknum = (txn1.check && txn1.check.number) || '';
                const bChecknum = (txn2.check && txn2.check.number) || '';
                if (aChecknum === bChecknum) {
                    cmpValue = compareDate(txn1, txn2);
                }
                else if (Number.isNaN(Number(aChecknum)) || Number.isNaN(Number(bChecknum))) {
                    cmpValue = (aChecknum === null || aChecknum === void 0 ? void 0 : aChecknum.toLowerCase()) < (bChecknum === null || bChecknum === void 0 ? void 0 : bChecknum.toLowerCase()) ? -1 : 1;
                }
                else {
                    cmpValue = Number(bChecknum) - Number(aChecknum);
                    // cmpValue = -1;
                }
                break;
            }
            case 'amount':
                cmpValue = 1;
                if (Number(txn1.amount) === Number(txn2.amount)) {
                    cmpValue = compareDate(txn1, txn2);
                }
                else if (Number(txn1.amount) < Number(txn2.amount)) {
                    cmpValue = -1;
                }
                break;
            case 'category': {
                const strA = txn1.coa ? chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, txn1.coa, true) : '';
                const strB = txn2.coa ? chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, txn2.coa, true) : '';
                cmpValue = 1;
                if (strA === strB) {
                    cmpValue = compareDate(txn1, txn2);
                }
                else if ((strA === null || strA === void 0 ? void 0 : strA.toLowerCase()) < (strB === null || strB === void 0 ? void 0 : strB.toLowerCase())) {
                    cmpValue = -1;
                }
                break;
            }
            case 'reviewed':
            case 'date':
                if (featureFlags && !featureFlags.get('labelPendingAsFuture')) {
                    if (txn1.state === 'PENDING' || txn2.state === 'PENDING') {
                        if (txn1.state === txn2.state) {
                            cmpValue = 0;
                        }
                        else {
                            cmpValue = txn1.state === 'PENDING' ? 1 : -1;
                        }
                    }
                }
                if (cmpValue === 0) {
                    cmpValue = (0, utils_1.transactionsSortFunction)(txn1, txn2);
                }
                break;
            case 'status':
                cmpValue = transactionsTypes_1.statusOrder.indexOf(txn1.state) - transactionsTypes_1.statusOrder.indexOf(txn2.state);
                if (cmpValue === 0) {
                    // for cash-flow uses, secondary-sort needs to be on date
                    cmpValue = compareDate(txn1, txn2);
                }
                break;
            default:
                break;
        }
        // if all else equal, sort by ID to guarantee repeatable sorting
        if (cmpValue === 0) {
            // @ts-expect-error - FIXME: txn1.id & txn2.id is possibly undefined
            cmpValue = txn1.id - txn2.id;
        }
        return cmpValue * sortFactor;
    });
    return sortedTxns;
}
exports.sortTransactions = sortTransactions;
